import authClient from '@/clients/authClient';
const login = (data) => authClient.post('login', data);

export default {
    login
}